/*eslint-disable*/
import React from 'react';
import { Pagination as MuiPagination } from '@mui/material';
import Box from '@mui/material/Box';

const paginationRootStyles = {
  fontSize: { xxl: '1.1rem', xl: '0.9rem', lg: '0.7rem', md: '0.7rem' },
  borderRadius: '0.438rem',
  color: '#42526E',
  width: { xxl: '2.5rem', xl: '1.875rem' },
  height: { xxl: '2.5rem', xl: '1.875rem' },
  margin: '0.125rem',
  '&:hover': {
    backgroundColor: '#ECEDF0',
  },
};
const selectedPagintionStyles = {
  backgroundColor: '#253858 !important',
  color: 'white !important',
  fontWeight: 'bold',
  width: { xxl: '2.5rem', xl: '1.875rem' },
  height: { xxl: '2.5rem', xl: '1.875rem' },
};
interface CommonPaginationProps {
  pageCount: number;
  page: number;
  onPageChange: (event: React.ChangeEvent<unknown>, newPage: number) => void;
  data: any[];
}

const Pagination = ({
  pageCount,
  page,
  onPageChange,
  data,
}: CommonPaginationProps)=> {
  const handleChange = (
    event: React.ChangeEvent<unknown>,
    selectedPage: number,
  ) => {
    if (selectedPage - 1 !== page) {
      onPageChange(event, selectedPage - 1);
    }
  };

  return (
    <>
      {data.length > 0 && (
        <Box
          sx={{
            mb: 'auto',
          }}
        >
          <MuiPagination
            size="small"
            count={pageCount > 0 ? pageCount : 1}
            page={page + 1}
            onChange={handleChange}
            color="primary"
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              '& .MuiPaginationItem-root': {
                ...paginationRootStyles,
              },
              '& .MuiPaginationItem-page.Mui-selected': {
                ...selectedPagintionStyles,
              },
              paddingTop: '0.5rem',
            }}
          />
        </Box>
      )}
    </>
  );
}

export default Pagination;
